// extracted by mini-css-extract-plugin
module.exports = {"close":"styles_close__3rE9z","badge":"styles_badge__3S55d"};